import { render, staticRenderFns } from "./specialCourseRegistration.vue?vue&type=template&id=313771b0"
import script from "./specialCourseRegistration.vue?vue&type=script&lang=js"
export * from "./specialCourseRegistration.vue?vue&type=script&lang=js"
import style0 from "./specialCourseRegistration.vue?vue&type=style&index=0&id=313771b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports